import ClientProfileDetailsPage from './clientProfileDetails';

export default ClientProfileDetailsPage;


// WEBPACK FOOTER //
// ./src/features/client-profile/pages/client-profile-details-page/index.js